// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_93444fe79c--checkbox--E83MD","box":"_93444fe79c--box--TSmoe","invalid":"_93444fe79c--invalid--duKFV","disabled":"_93444fe79c--disabled--WW5p9"};